function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React from 'react';
import { cx } from '@emotion/css';
import { FolderOutlinedIcon } from "../Icons";
import ArrowRightFilledIcon from "../Icons/ArrowRightFilledIcon";
import ThemeProvider from "../ThemeProvider";
import { TreeContext } from "./Tree";
import { childrenClass, childrenHideClass, contentClass, contentItemClass, customColor, ellipsisClass, expandedIconClass, expandIconContainerClass, leftSpaceClass, linePseudo, nodeClass, nodeSelectedClass, rightSpaceClass, selectBlockClass, titleClass } from "./index.style";
import useThemeProps from "../../hooks/useThemeProps";
import { useOnUpdate } from "../../hooks/useOnUpdate";
import Checkbox from "../Checkbox";
import { useFreshFunction } from "../../hooks/useFreshFunction";
import { useFreshStaticValue } from "../../hooks/useFreshStaticValue";
import { getColor } from "../../utils/color"; // for SearchTree

export var TreeNodeContext = /*#__PURE__*/React.createContext(null);
TreeNodeContext.displayName = 'TreeNodeContext';
var TreeNode = /*#__PURE__*/React.memo(function (_ref, ref) {
  var _treeNodeModel$treeNo5, _cx;

  var level = _ref.level,
      nodeKey = _ref.nodeKey,
      _treeNode = _ref.treeNode,
      isUseExpand = _ref.isUseExpand;
  var inject = React.useContext(TreeContext);
  var theme = useThemeProps();
  var treeNodeModel = inject.treeModel.getModel(nodeKey);

  var _inject = useFreshStaticValue(inject, {
    type: 'replace'
  });

  var showIcon = inject.showIcon,
      _disabled = inject.disabled,
      layoutConfig = inject.layoutConfig,
      checkable = inject.checkable;
  var disabled = treeNodeModel.treeNode.disabled || _disabled; // 对比 treeNode 强制更新

  var _React$useState = React.useState(_objectSpread({}, _treeNode)),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      setTreeNode = _React$useState2[1];

  var _React$useState3 = React.useState(treeNodeModel.getChecked(nodeKey, _inject.current.staticConfig.strict)),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      _checked = _React$useState4[0],
      setChecked = _React$useState4[1];

  var _React$useState5 = React.useState(treeNodeModel.getSelected(nodeKey)),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      selected = _React$useState6[0],
      setSelected = _React$useState6[1];

  var _React$useState7 = React.useState(!inject.staticConfig.strict && treeNodeModel.snapshot.indeterminate),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      indeterminate = _React$useState8[0],
      setInderminate = _React$useState8[1];

  var _React$useState9 = React.useState(treeNodeModel.getExpanded(nodeKey)),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      isExpand = _React$useState10[0],
      setIsExpand = _React$useState10[1];

  var _React$useState11 = React.useState(false),
      _React$useState12 = _slicedToArray(_React$useState11, 2),
      loading = _React$useState12[0],
      setLoading = _React$useState12[1];

  var contentWrapper = React.useRef(null);
  var status = React.useRef({});
  var expandContainer = React.useRef(null);
  var iconContainer = React.useRef(null);
  var checkboxContainer = React.useRef(null);
  var labelContainer = React.useRef(null);
  var selectBlockContainer = React.useRef(null);
  var childrenWrapper = React.useRef(null);
  var combine = React.useCallback(function (key) {
    var treeModel = _inject.current.treeModel;
    var treeNodeModel = treeModel.getModel(key);
    var baseTrigger = treeModel.trigger;
    var timer;
    var t = {
      timer: timer
    };

    treeNodeModel.trigger = function (payload, callback) {
      baseTrigger(payload, function (model, event) {
        callback && callback(model, event); // 保证节点正确，不存在闭包

        var treeNodeModel = _inject.current.treeModel.getModel(key);

        if (payload.type === 'expand') {
          var treeNode = treeNodeModel.treeNode;

          if (treeNode.isLoadedChildren) {
            setIsExpand(function (prev) {
              var _inject$current = _inject.current,
                  treeModel = _inject$current.treeModel,
                  expandAnimation = _inject$current.staticConfig.expandAnimation;

              var _isExpand = treeNodeModel.getExpanded(nodeKey);

              var newVal = _isExpand;

              if (newVal === prev) {
                return prev;
              }

              treeModel.target = treeNodeModel;

              if (expandAnimation && payload.animation) {
                expand(treeNodeModel, !_isExpand);
                cancelAnimationFrame(t.timer);
                t.timer = requestAnimationFrame(function () {
                  expand(treeNodeModel, newVal);
                });
              }

              return newVal;
            });
          } else if (payload.expanded) {
            // 获取最新的 loading
            if (!status.current.isLoading) {
              status.current.isLoading = true;
              appendChildren(treeNodeModel).then(function () {
                treeNodeModel.trigger({
                  type: 'expand',
                  expanded: true,
                  currentItem: treeNodeModel.treeNode,
                  model: _inject.current.treeModel.getModel(treeNodeModel.pKey),
                  animation: payload.animation
                });
              }).catch(function () {
                treeNodeModel.trigger({
                  type: 'expand',
                  expanded: false,
                  currentItem: treeNodeModel.treeNode,
                  model: _inject.current.treeModel.getModel(treeNodeModel.pKey),
                  animation: false
                });
              }).finally(function () {
                status.current.isLoading = false;
              });
            }

            return loading;
          } else {
            setIsExpand(false);
          }

          return;
        }

        if (payload.type === 'refresh') {
          setTreeNode(function (prev) {
            var node = treeNodeModel.treeNode;
            var fields = Object.keys(node);

            for (var i = 0; i < fields.length; i++) {
              var field = fields[i];

              if (node[field] !== prev[field]) {
                return _objectSpread({}, treeNodeModel.treeNode);
              }
            }

            return prev;
          });
          setLoading(false);
        } // checkbox


        if (event.target !== treeNodeModel) {
          setChecked(treeNodeModel.getChecked(treeNodeModel.treeNode.key, _inject.current.staticConfig.strict));
        }

        if (!_inject.current.staticConfig.strict) {
          setInderminate(treeNodeModel.snapshot.indeterminate);
        } else {
          setInderminate(false);
        } // select


        setSelected(treeNodeModel.getSelected(treeNodeModel.treeNode.key));
      });
    };

    return t;
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [nodeKey]);
  React.useEffect(function () {
    var t = combine(nodeKey);
    return function () {
      cancelAnimationFrame(t.timer);
    };
  }, [treeNodeModel, combine, nodeKey, _treeNode]);
  useOnUpdate(function () {
    treeNodeModel.trigger({
      type: 'refresh'
    });
  }, [treeNodeModel, nodeKey]); // 算总高

  React.useEffect(function () {
    var _treeNodeModel$treeNo;

    // register
    var height = 0;

    if (!((_treeNodeModel$treeNo = treeNodeModel.treeNode.useEllipsis) !== null && _treeNodeModel$treeNo !== void 0 ? _treeNodeModel$treeNo : _inject.current.useEllipsis)) {
      var _contentWrapper$curre, _contentWrapper$curre2;

      height = (_contentWrapper$curre = (_contentWrapper$curre2 = contentWrapper.current) === null || _contentWrapper$curre2 === void 0 ? void 0 : _contentWrapper$curre2.offsetHeight) !== null && _contentWrapper$curre !== void 0 ? _contentWrapper$curre : 0;
    } else {
      // eslint-disable-next-line prefer-destructuring
      height = _inject.current.layoutConfig.height;
    }

    treeNodeModel.layout.height = height;
    var p = treeNodeModel;

    while (p = p.getModel(p.pKey)) {
      p.layout.childrenHeight += height;
    }

    return function () {
      var p = treeNodeModel;

      while (p = p.getModel(p.pKey)) {
        p.layout.childrenHeight -= height;
      }
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nodeKey, treeNodeModel.treeNode.title, _inject.current.useEllipsis, treeNodeModel.treeNode.useEllipsis]);
  /* ------------------------- checkbox ------------------------- */

  var onChange = useFreshFunction(function (checked) {
    if (disabled) return;
    var _inject$current2 = _inject.current,
        treeModel = _inject$current2.treeModel,
        strict = _inject$current2.staticConfig.strict;
    var treeNode = treeNodeModel.treeNode;
    var c = checked ? 'all' : 'none';
    treeModel.target = treeNodeModel;
    var root = treeModel.getRoot();
    var isRoot = root === treeNodeModel;
    var getModel = treeModel.getModel;
    /* 受控 */

    if (!_inject.current.INNER_MODE) {
      var checkedKeys = new Set(treeModel.selectedKeys);
      var particalCheckedKeys = new Set(treeModel.partialKeys);
      var filteredKeys = new Set();
      var lastKey = treeNode.key;

      var assumePropagation = function assumePropagation(model, _ref2) {
        var newSnapshot = _ref2.newSnapshot;
        if (!newSnapshot) return;
        var computeCheckedWithChildren = treeModel.computeCheckedWithChildren,
            getRoot = treeModel.getRoot,
            getModel = treeModel.getModel;
        var status = computeCheckedWithChildren(newSnapshot);
        var oldStatus = computeCheckedWithChildren(model.snapshot);

        if (status === oldStatus || model === getRoot()) {
          var createModel = treeModel.createModel,
              computeFilteredKeys = treeModel.computeFilteredKeys;
          model = createModel(model.pKey, model.level, newSnapshot, model.treeNode);

          while (model) {
            // eslint-disable-next-line no-loop-func
            var filteredKeysArr = computeFilteredKeys(model, function (_ref3) {
              var key = _ref3.key;
              return key === lastKey ? undefined : getModel(key);
            });
            filteredKeysArr.forEach(function (key) {
              filteredKeys.add(key);
            });
            lastKey = model.treeNode.key;
            model = treeModel.getModel(model.pKey);
          }

          return;
        }

        var currentItem = model.treeNode;
        var key = currentItem.key;

        switch (status) {
          case 'all':
            if (!checkedKeys.has(key)) {
              checkedKeys.add(key);
            }

            currentItem.children.forEach(function (_ref4) {
              var key = _ref4.key;

              if (filteredKeys.has(key)) {
                filteredKeys.delete(key);
              }
            });
            break;

          case 'part':
            if (!particalCheckedKeys.has(key)) {
              particalCheckedKeys.add(key);
            }

            var checkGroup = newSnapshot.checkGroup,
                indexMap = newSnapshot.indexMap;
            currentItem.children.forEach(function (_ref5) {
              var key = _ref5.key;

              if (checkGroup[indexMap[key]] === 'all' && !filteredKeys.has(key)) {
                filteredKeys.add(key);
              }
            });
            break;
        }

        switch (oldStatus) {
          case 'all':
            if (checkedKeys.has(key)) {
              checkedKeys.delete(key);
            }

            break;

          case 'part':
            if (particalCheckedKeys.has(key)) {
              particalCheckedKeys.delete(key);
            }

            break;
        }

        lastKey = key;
        treeModel.trigger({
          type: 'checked-one',
          checked: status,
          currentItem: currentItem,
          model: getModel(model.pKey),
          assume: true
        }, assumePropagation);
      };

      if (isRoot) {
        treeNodeModel.treeNode.children.forEach(function (_ref6) {
          var key = _ref6.key;

          if (checked) {
            filteredKeys.add(key);
          }
        });
      } else if (!strict) {
        treeModel.trigger({
          type: 'checked-one',
          checked: c,
          currentItem: treeNode,
          model: getModel(treeNodeModel.pKey),
          assume: true
        }, assumePropagation);
      } else {
        var key = treeNodeModel.treeNode.key;

        if (checked) {
          checkedKeys.add(key);
        } else {
          if (checkedKeys.has(key)) {
            checkedKeys.delete(key);
          }
        }
      } // 向下


      if (!strict || isRoot) {
        var method = checked ? 'add' : 'delete';
        treeModel.dfs(treeNodeModel, function (m) {
          var key = m.treeNode.key;
          checkedKeys[method](key);

          if (particalCheckedKeys.has(key)) {
            particalCheckedKeys.delete(key);
          }

          return m.treeNode.children;
        }, function (_ref7) {
          var key = _ref7.key;
          return getModel(key);
        });
      }

      treeModel.target = undefined;
      checkedKeys.delete(root.treeNode.key);
      particalCheckedKeys.delete(root.treeNode.key);
      _inject.current.staticConfig.onCheck && _inject.current.staticConfig.onCheck({
        checked: checked,
        current: treeNode.key,
        selectedKeys: _toConsumableArray(checkedKeys),
        particalSelectedKeys: _toConsumableArray(particalCheckedKeys),
        filteredKeys: _toConsumableArray(filteredKeys)
      });
      return;
    } // 改变当前节点


    setChecked(checked); // 向下

    if (isRoot) {
      treeModel.chooseNodeAllChildren(treeNode.key, c);
    } else if (!strict) {
      treeModel.chooseNodeAllChildren(treeNode.key, c);
      treeModel.chooseNodeAndComputeParentNode(treeNode.key, c);
    } else {
      treeModel.chooseNodeStrict(treeNode.key, c);
    }

    treeModel._run(function () {
      var result = treeModel.getSelectedKeys(root, strict);
      var filteredKeys = strict ? [] : treeModel.computeFilteredKeys(root, function (_ref8) {
        var key = _ref8.key;
        return getModel(key);
      });
      _inject.current.staticConfig.onCheck && _inject.current.staticConfig.onCheck(_objectSpread(_objectSpread({
        current: treeNode.key,
        checked: checked
      }, result), {}, {
        filteredKeys: filteredKeys
      }));
      treeModel.target = undefined;
    });
  });
  /* ------------------------- expand ------------------------- */

  var _React$useState13 = React.useState(undefined),
      _React$useState14 = _slicedToArray(_React$useState13, 2),
      expandStyle = _React$useState14[0],
      setExpandStyle = _React$useState14[1];

  var expand = React.useCallback(function (treeNodeModel, isExpand) {
    // 计算 model子节点的展开数量
    var count = 0;

    if (isExpand) {
      var _treeNodeModel$treeNo2;

      if ((_treeNodeModel$treeNo2 = treeNodeModel.treeNode.useEllipsis) !== null && _treeNodeModel$treeNo2 !== void 0 ? _treeNodeModel$treeNo2 : _inject.current.useEllipsis) {
        // 不换行
        treeNodeModel.dfs(treeNodeModel, function (m) {
          var isExpanded = m.getExpanded(m.treeNode.key);

          if (treeNodeModel === m ? isExpand : isExpanded) {
            count += m.treeNode.children.length;
            return m.treeNode.children;
          }

          return [];
        }, function (_ref9) {
          var key = _ref9.key;
          return treeNodeModel.getModel(key);
        });
        setExpandStyle({
          height: _inject.current.layoutConfig.height * count
        });
      } else {
        if (childrenWrapper.current) {
          setExpandStyle({
            height: childrenWrapper.current.scrollHeight
          });
        } else {
          setExpandStyle(undefined);
        }
      }
    } else {
      setExpandStyle({
        height: 0
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);

  var onExpand = function onExpand(newExpanded) {
    var _inject$current3 = _inject.current,
        treeModel = _inject$current3.treeModel,
        userCallback = _inject$current3.staticConfig.onExpand;
    treeNodeModel.trigger({
      type: 'expand',
      expanded: newExpanded,
      currentItem: treeNodeModel.treeNode,
      model: treeModel.getModel(treeNodeModel.pKey),
      animation: true
    });
    userCallback && userCallback({
      key: treeNodeModel.treeNode.key,
      expanded: newExpanded
    });
  };

  var handleTransitionEnd = React.useCallback(function (e) {
    e.stopPropagation();
    setExpandStyle(undefined);
  }, []);
  React.useEffect(function () {
    if (isUseExpand && isExpand && !treeNodeModel.treeNode.isLoadedChildren) {
      treeNodeModel.trigger({
        type: 'expand',
        expanded: true,
        currentItem: treeNodeModel.treeNode,
        model: _inject.current.treeModel.getModel(treeNodeModel.treeNode.key),
        animation: true
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [treeNodeModel.treeNode, treeNodeModel.treeNode.loadData]);
  /* ------------------------- lazy, loadData ------------------------- */

  var appendChildren = function appendChildren(treeNodeModel) {
    var treeNode = treeNodeModel.treeNode;

    if (treeNode.loadData) {
      setLoading(true);
      return treeNode.loadData().then(function (treeData) {
        var treeModel = _inject.current.treeModel;

        if (Array.isArray(treeData) && treeData.length > 0) {
          var oldTreeNode = treeNodeModel.treeNode;
          oldTreeNode.children = treeData; // 挂载新children

          treeModel.initialize(treeNodeModel.pKey, oldTreeNode, _toConsumableArray(treeModel.selectedKeys), _toConsumableArray(treeModel.expandedKeys), treeNodeModel.level, {
            lazy: _inject.current.staticConfig.lazy,
            defaultExpandAll: _inject.current.staticConfig.defaultExpandAll,
            strict: _inject.current.staticConfig.strict
          });

          treeModel._run(function () {
            combine(nodeKey);
            treeNodeModel.treeNode.isLoadedChildren = true;
            treeNodeModel.trigger({
              type: 'refresh'
            });
          });
        }
      }).finally(function () {
        return setLoading(false);
      });
    } else {
      if (treeNode.children.length > 0 && !treeNodeModel.treeNode.isLoadedChildren) {
        treeNodeModel.treeNode.isLoadedChildren = true;
        treeNodeModel.trigger({
          type: 'refresh'
        });
        return Promise.resolve();
      }

      return Promise.reject();
    }
  };
  /* ------------------------- other ------------------------- */


  var onNodeClick = function onNodeClick(e) {
    var _activeEl;

    var flag = true;
    var activeEl = e.target;
    var payload = {
      type: 'node',
      activeNodeKey: nodeKey,
      expand: function expand(expanded) {
        if (payload.type === 'expand' || !isUseExpand) return;

        var model = _inject.current.treeModel.getModel(nodeKey);

        if (!model) return;
        var currentExpand = model.getExpanded(nodeKey);

        if (typeof expanded === 'boolean') {
          if (currentExpand === expanded || model.treeNode.children.length === 0 && !model.treeNode.loadData) {
            return;
          }

          onExpand(expanded);
        } else {
          onExpand(!currentExpand);
        }
      },
      check: function check(checked) {
        if (payload.type === 'checkbox') return;

        var model = _inject.current.treeModel.getModel(nodeKey);

        if (!model) return;

        var currentChecked = _inject.current.treeModel.getChecked(nodeKey, _inject.current.staticConfig.strict);

        if (typeof checked === 'boolean') {
          if (checked === currentChecked) return;
          onChange(checked);
        } else {
          onChange(!currentChecked);
        }
      },
      select: function select(_select) {
        if (['select', 'label', 'icon'].includes(payload.type) || _inject.current.checkable) {
          return;
        }

        var model = _inject.current.treeModel.getModel(nodeKey);

        if (!model) return;

        var currentSelected = _inject.current.treeModel.getSelected(nodeKey);

        if (typeof _select === 'boolean') {
          if (currentSelected === _select) return;
          onSelect(_select);
        } else {
          onSelect(!currentSelected);
        }
      }
    };

    while (flag) {
      if (activeEl == null) {
        payload.type = 'node';
        break;
      }

      switch (activeEl) {
        case expandContainer.current:
          flag = false;
          payload.type = 'expand';
          break;

        case checkboxContainer.current:
          flag = false;
          payload.type = 'checkbox';
          break;

        case selectBlockContainer.current:
          flag = false;
          payload.type = 'select';
          break;

        case iconContainer.current:
          flag = false;
          payload.type = 'icon';
          break;

        case labelContainer.current:
          flag = false;
          payload.type = 'label';
          break;

        case contentWrapper.current:
          flag = false;
          payload.type = 'node';
          break;

        default:
          activeEl = (_activeEl = activeEl) === null || _activeEl === void 0 ? void 0 : _activeEl.parentNode;
      }
    }

    var onNodeClick = _inject.current.staticConfig.onNodeClick;
    onNodeClick && onNodeClick(payload);
  };
  /* ------------------------- select ------------------------- */


  var onSelect = function onSelect(selected) {
    var _model$treeNode;

    if (disabled) return;

    var model = _inject.current.treeModel.getModel(nodeKey);

    model.trigger({
      type: 'select',
      assume: !_inject.current.INNER_MODE,
      currentItem: model.treeNode,
      value: selected
    });
    var onSelect = _inject.current.staticConfig.onSelect;
    onSelect && onSelect({
      selectedKeys: [model === null || model === void 0 ? void 0 : (_model$treeNode = model.treeNode) === null || _model$treeNode === void 0 ? void 0 : _model$treeNode.key],
      selected: selected
    });
  };
  /* ------------------------- line ------------------------- */


  var line = React.useMemo(function () {
    var treeNode = treeNodeModel.treeNode;
    return linePseudo(level, getColor(theme, treeNode.lineColor), layoutConfig, theme); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [layoutConfig, treeNodeModel.treeNode.lineColor, theme, level]);
  /* ------------------------- icon ------------------------- */

  var iconSlot = React.useMemo(function () {
    var _treeNodeModel$treeNo3 = treeNodeModel.treeNode,
        icon = _treeNodeModel$treeNo3.icon,
        iconColor = _treeNodeModel$treeNo3.iconColor;

    if (!showIcon) {
      return null;
    }

    var iconClassName = cx(contentItemClass(), leftSpaceClass(), rightSpaceClass(), 'tree-node-icon--clear');
    var mergedIconColor = !checkable && selected ? treeNodeModel.treeNode.iconSelectActiveColor : iconColor;

    if (typeof icon === 'function') {
      return /*#__PURE__*/React.createElement("div", {
        ref: iconContainer,
        className: iconClassName
      }, icon({
        checked: _checked,
        selected: selected,
        disabled: disabled,
        layoutConfig: _objectSpread({}, layoutConfig),
        defaultIcon: FolderOutlinedIcon
      }));
    } else if (icon === undefined) {
      return /*#__PURE__*/React.createElement("div", {
        ref: iconContainer,
        className: iconClassName
      }, disabled ? /*#__PURE__*/React.createElement(ThemeProvider, {
        value: {
          system: 'light'
        }
      }, /*#__PURE__*/React.createElement(FolderOutlinedIcon, {
        fill: theme.isSyetemThemeDark ? 'primary' : 'fourth',
        size: layoutConfig.iconSize
      })) : /*#__PURE__*/React.createElement(FolderOutlinedIcon, {
        fill: mergedIconColor,
        size: layoutConfig.iconSize
      }));
    } else if (icon !== null) {
      return /*#__PURE__*/React.createElement("div", {
        ref: iconContainer,
        className: iconClassName
      }, icon);
    } else {
      return null;
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [treeNodeModel.treeNode.icon, treeNodeModel.treeNode.iconSelectActiveColor, disabled, showIcon, layoutConfig, theme, _checked, selected, checkable]);
  /* ------------------------- title ------------------------- */

  var _title = React.useMemo(function () {
    var title = treeNodeModel.treeNode.title;
    return typeof title === 'function' ? title({
      checked: _checked,
      selected: selected,
      expanded: isExpand,
      disabled: disabled
    }) : title; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [treeNodeModel.treeNode.title, _checked, selected, isExpand, disabled, nodeKey]);

  treeNodeModel.treeNode._title = _title;
  var nodeContext = useFreshStaticValue({
    nodeKey: nodeKey
  });
  var labelSlot = React.useMemo(function () {
    var _treeNodeModel$treeNo4 = treeNodeModel.treeNode,
        titleSelectActiveColor = _treeNodeModel$treeNo4.titleSelectActiveColor,
        color = _treeNodeModel$treeNo4.color;
    var titleColor = !checkable && selected ? titleSelectActiveColor : color;
    var mergedTitleColor = getColor(theme, titleColor);
    var labelElement =
    /*#__PURE__*/
    // for SearchTree
    React.createElement(TreeNodeContext.Provider, {
      value: nodeContext.current
    }, _title);
    return /*#__PURE__*/React.createElement("div", {
      ref: labelContainer,
      className: cx(titleClass(), leftSpaceClass(), rightSpaceClass(), customColor(mergedTitleColor)),
      onMouseEnter: function onMouseEnter(e) {
        var useEllipsis = _inject.current.treeModel.getModel(nodeKey).treeNode.useEllipsis;

        if (!(useEllipsis !== null && useEllipsis !== void 0 ? useEllipsis : _inject.current.useEllipsis)) return;
        e.stopPropagation();
        clearTimeout(_inject.current.timer);
        _inject.current.timer = setTimeout(function () {
          var _inject$current4 = _inject.current,
              _inject$current4$stat = _inject$current4.staticConfig,
              contentEl = _inject$current4$stat.contentEl,
              tooltip = _inject$current4$stat.tooltip,
              noStyle = _inject$current4$stat.noStyle,
              header = _inject$current4$stat.header,
              _inject$current4$layo = _inject$current4.layoutConfig,
              height = _inject$current4$layo.height,
              lineHeight = _inject$current4$layo.lineHeight;
          var style = {};

          if (contentWrapper.current && contentEl.current) {
            var titleEl = contentWrapper.current.querySelector(".".concat(titleClass()));
            if (!titleEl) return tooltip(null);

            var _titleEl$getBoundingC = titleEl.getBoundingClientRect(),
                y = _titleEl$getBoundingC.y;

            var totalWidth = titleEl.scrollWidth,
                totalHeight = titleEl.scrollHeight; // 没省略

            if (titleEl.offsetWidth >= totalWidth && totalHeight <= height) {
              return tooltip(null);
            }

            var containerY = contentEl.current.getBoundingClientRect().y; // 节点上方

            style.top = y - containerY;
            /* header */

            if (header) {
              style.top += 17 + height;
            }

            if (totalHeight >= 2 * height || totalWidth > 400
            /* 跟随 tootip 的 max-widths */
            ) {
              // 节点下方
              style.top += height;
            } else {
              // 节点上方
              style.top -= 26 + lineHeight;
              /* padding + 字体行高 */
            }

            if (!noStyle) {
              // padding
              style.top += 11;
            }
          }

          tooltip( /*#__PURE__*/React.createElement("div", {
            className: customColor(mergedTitleColor)
          }, /*#__PURE__*/React.cloneElement(labelElement, {
            value: {
              nodeKey: nodeKey,
              isClone: true
            }
          })), style);
        }, 400);
      },
      onMouseLeave: function onMouseLeave(e) {
        var useEllipsis = _inject.current.treeModel.getModel(nodeKey).treeNode.useEllipsis;

        if (!(useEllipsis !== null && useEllipsis !== void 0 ? useEllipsis : _inject.current.useEllipsis)) return;
        e.stopPropagation();
        clearTimeout(_inject.current.timer);
        _inject.current.timer = setTimeout(function () {
          _inject.current.staticConfig.tooltip(null);
        }, 400);
      }
    }, labelElement); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_title, treeNodeModel.treeNode.titleSelectActiveColor, treeNodeModel.treeNode.color, checkable, selected, nodeKey, theme]);
  /* ------------------------- children ------------------------- */

  var childrenContent = React.useMemo(function () {
    var treeNode = treeNodeModel.treeNode;
    var treeModel = _inject.current.treeModel;
    return treeNode.isLoadedChildren ? treeNode.children.map(function (item) {
      var model = treeModel.getModel(item.key); // eslint-disable-next-line no-nested-ternary

      return model ? /*#__PURE__*/React.createElement(TreeNode, {
        treeNode: item,
        nodeKey: item.key,
        level: level + 1,
        key: item.key,
        isUseExpand: true
      }) : process.env.NODE_ENV === 'development' ? /*#__PURE__*/React.createElement("div", null, "unexist node ", item.key) : /*#__PURE__*/React.createElement("div", {
        className: nodeClass()
      }, /*#__PURE__*/React.createElement("div", {
        className: contentClass()
      }));
    }) : null; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [treeNodeModel.treeNode.children, treeNodeModel.treeNode.isLoadedChildren]);
  return /*#__PURE__*/React.createElement("div", {
    className: cx(nodeClass(), (_cx = {}, _defineProperty(_cx, line, _inject.current.showLine && isUseExpand && isExpand), _defineProperty(_cx, ellipsisClass(), (_treeNodeModel$treeNo5 = treeNodeModel.treeNode.useEllipsis) !== null && _treeNodeModel$treeNo5 !== void 0 ? _treeNodeModel$treeNo5 : _inject.current.useEllipsis), _cx))
  }, /*#__PURE__*/React.createElement("div", {
    className: contentClass(),
    ref: contentWrapper,
    style: {
      paddingLeft: level * layoutConfig.indent + 'px'
    },
    onClick: onNodeClick
  }, isUseExpand && (treeNodeModel.treeNode.children.length > 0 || Boolean(treeNodeModel.treeNode.loadData) ? /*#__PURE__*/React.createElement("div", {
    ref: expandContainer,
    className: cx(contentItemClass(), expandIconContainerClass(), rightSpaceClass(), 'cursor', _defineProperty({}, expandedIconClass(), isExpand)),
    onClick: function onClick() {
      return onExpand(!treeNodeModel.getExpanded(nodeKey));
    }
  }, /*#__PURE__*/React.createElement(ArrowRightFilledIcon, {
    fill: "secondary",
    size: layoutConfig.iconSize
  })) : /*#__PURE__*/React.createElement("div", {
    className: cx(contentItemClass(), expandIconContainerClass(), rightSpaceClass())
  })), _inject.current.checkable && treeNodeModel.treeNode.selectable && /*#__PURE__*/React.createElement(Checkbox, {
    ref: checkboxContainer,
    size: _inject.current.layoutConfig.size,
    disabled: disabled,
    className: cx(contentItemClass(), rightSpaceClass(), _defineProperty({}, leftSpaceClass(), isUseExpand)),
    checked: _checked,
    indeterminate: indeterminate,
    onChange: onChange
  }), _inject.current.checkable ? /*#__PURE__*/React.createElement(React.Fragment, null, iconSlot, labelSlot) : /*#__PURE__*/React.createElement("div", {
    ref: selectBlockContainer,
    className: cx(selectBlockClass(), _defineProperty({}, nodeSelectedClass(), selected)),
    onClick: function onClick() {
      return onSelect(!_inject.current.treeModel.getSelected(nodeKey));
    }
  }, iconSlot, labelSlot)), !_inject.current.treeModel.isRoot(nodeKey) && (!loading ? treeNodeModel.treeNode.isLoadedChildren && /*#__PURE__*/React.createElement("div", {
    ref: childrenWrapper,
    style: expandStyle,
    onTransitionEnd: handleTransitionEnd,
    className: cx(childrenClass(), _defineProperty({}, childrenHideClass(), !isExpand))
  }, childrenContent) : /*#__PURE__*/React.createElement("div", {
    style: {
      paddingLeft: level * layoutConfig.indent + 'px'
    },
    className: childrenClass()
  }, "loading")));
});
TreeNode.displayName = 'TreeNode';
export default TreeNode;